package com.essntl.core.stripe.domain.models

data class Price(
    val id: String,
)
